export default {
  onboarding: {
    title: 'This is a SAFE Tag!',
    description: 'You can link your SAFE Tag and start being protected by SOSAFE',
  },
  linkSafetag: 'Link SAFE Tag',
  disclaimerSosafe: 'Download the latest version of SOSAFE to link your SAFE Tag',
};
